// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { configureBudgetStyles } from "@insite/content-library/Widgets/Budget/ConfigureBudget";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { getSystemZIndex } from "@stanion/XDL/Utilities";
import { css } from "styled-components";

configureBudgetStyles.cancelButton = {
    variant: "secondary",
};

configureBudgetStyles.buttonsGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        button {
            display: inline-block;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    justify-content: flex-start;
                `,
                css`
                    justify-content: flex-start;
                `,
                css`
                    justify-content: flex-end;
                `,
                css`
                    justify-content: flex-end;
                `,
                css`
                    justify-content: flex-end;
                `,
            ])}
    `,
};

configureBudgetStyles.startDatePicker = {
    cssOverrides: {
        datePicker: css`
            width: 100%;
            .react-datetime-picker__calendar {
                z-index: ${getSystemZIndex("popover")};
            }
        `,
    },
};
configureBudgetStyles.gridItems = {
    css: css`
        > div {
            overflow-y: unset;
            overflow-x: unset;
        }
    `,
};
